import {WidgetJSAPI} from "./WidgetJSAPI";

window.OneIdApi = new WidgetJSAPI();
const widgetScriptElement = document.getElementById("oneid_widget_data_script") as HTMLScriptElement | null;

if (widgetScriptElement) {
    const content = widgetScriptElement.innerText;
    const jsonData = JSON.parse(content);
    const selector = jsonData.container.startsWith(".") ? jsonData.container : "#" + jsonData.container;
    const containers = document.querySelectorAll(selector);

    for (const container of containers) {
        if (container) {
            window.OneIdApi.initialize({
                container,
                verifyAge: jsonData.verifyAge,
                installMethod: jsonData.installMethod,
            });
        }
    }
} else {
    console.log("nope");

}
